import {
    CadastrarCustasService,
    GetPadraoCobrancaService,
    ListarCapService,
    ListarFrequenciaVencimentoService,
    ListarIndiceReajusteParcelaService,
    ListarPadraoCobrancaService,
    ListarPlanoIndexadorService,
    ListarTiposDeCustasService,
} from "../../../Services/Geral/LancamentoCustas/LancamentoCustasService";
import { IParcelasCustasRequest } from "../../../Interfaces/Geral/LancamentoCustas/LancamentoCustasInterface";
import { Controller } from "../../Controller";

export async function ListarPlanoIndexadorController(
    empresa: string,
    obra: string,
    venda: string
) {
    return Controller(ListarPlanoIndexadorService(empresa, obra, venda));
}

export async function ListarIndiceReajusteParcelaController() {
    return Controller(ListarIndiceReajusteParcelaService());
}

export async function ListarFrequenciaVencimentoController() {
    return Controller(ListarFrequenciaVencimentoService());
}

export async function ListarPadraoCobrancaController(empresa: string) {
    return Controller(ListarPadraoCobrancaService(empresa));
}

export async function ListarTiposDeCustasController() {
    return Controller(ListarTiposDeCustasService());
}

export async function ListarCapController() {
    return Controller(ListarCapService());
}

export async function CadastrarCustasController(
    idCaso: number,
    idTipoCaso: number,
    filtroParcelasCustas: IParcelasCustasRequest
) {
    return Controller(
        CadastrarCustasService(idCaso, idTipoCaso, filtroParcelasCustas)
    );
}

export async function GetPadraoCobrancaController(
    empresa: string,
    obra: string
) {
    return Controller(GetPadraoCobrancaService(empresa, obra));
}
